import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";

export default function TopPage({ kjprofitSum }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="p-4">
      <div className="w-full bg-neutral-900 p-4 rounded-xl shadow-card">
        <div className="mb-2">
          <span className="text-neutral-400 text-sm">
            {translate(getText("託管的資金"))}
          </span>
        </div>
        <div className="flex items-baseline mb-6">
          <span className="text-4xl font-bold text-white mr-2">
            {kjprofitSum.buynum}
          </span>
          <span className="text-neutral-400">USDT</span>
        </div>
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="text-center">
            <div className="mb-1">
              <span className="text-xl font-medium text-success">
                {kjprofitSum.todaynum}
              </span>
            </div>
            <div>
              <span className="text-xs text-neutral-400">
                {translate(getText("預計今日的收益"))}
              </span>
            </div>
          </div>
          <div className="text-center border-l border-r border-neutral-700">
            <div className="mb-1">
              <span className="text-xl font-medium text-primary-light">
                {kjprofitSum.sumnum}
              </span>
            </div>
            <div>
              <span className="text-xs text-neutral-400">
                {translate(getText("累計收益"))}
              </span>
            </div>
          </div>
          <div className="text-center">
            <div className="mb-1">
              <span className="text-xl font-medium text-info">
                {kjprofitSum.count}
              </span>
            </div>
            <div>
              <span className="text-xs text-neutral-400">
                {translate(getText("託管中的訂單"))}
              </span>
            </div>
          </div>
        </div>
        <button
          className="w-full py-2 px-4 bg-gradient-primary rounded-lg text-black hover:opacity-90 transition-opacity"
          onClick={() => {
            navigate("/lockUpOrder");
          }}
        >
          {translate(getText("委託訂單"))}
        </button>
      </div>
    </div>
  );
}
